import MessageGenerateToHtml from "./MessageGenerateToHtml";

export default function BodyComponent({ detail }) {
    return (
        <MessageGenerateToHtml message={detail?.body?.text ?? ''} />
    )
}